<script>

    import { onMount, onDestroy } from 'svelte'
    import { fade } from 'svelte/transition'
    import { createEventDispatcher } from 'svelte'

    import { modalStore } from '../stores'

    const dispatch = createEventDispatcher()

    export let title = ''
    export let id = ''
    export let sizeWeb = ''
    export let tall = false

    $: show = $modalStore === id

    function onClose() {
        modalStore.close()
        dispatch('close')
    }

    function handleKeydown(event) {
        if (show && event.key === 'Escape') onClose()
    }

    onMount(() => window.addEventListener('keydown', handleKeydown))
    onDestroy(() => window.removeEventListener('keydown', handleKeydown))

</script>

{#if show}
    <div class="modal" class:is-active={show} in:fade="{{duration: 200}}" out:fade="{{duration: 100}}">
        <div on:click={onClose} class="modal-background"></div>
        <div class="modal-card" class:is-tall={tall} style={sizeWeb ? `width: ${sizeWeb}; max-width: ${sizeWeb};` : ''}>
            <div class="modal-card-head">
                <div class="modal-card-title">{ title }</div>
                <button on:click={onClose} class="delete" aria-label="close"></button>
            </div>
            <div class="modal-card-body">
                <slot></slot>
            </div>
            <div class="modal-card-foot"></div>
        </div>
    </div>
{/if}

<style>
    .modal-card.is-tall {
        width: min(1100px, calc(100vw - 2rem));
        max-width: min(1100px, calc(100vw - 2rem));
        height: auto;
        max-height: calc(100vh - 2.5rem);
    }
</style>
